import { watch } from 'vue'

import { useAuthenticationStore } from '@cplug/frontend-shared-domains/domain/authentication'
import useFeatureFlagStore from '~/domain/shared/feature-flag/stores/useFeatureFlagStore'
import type { ExtendedCPlugAPI } from '~/global/types/runtime-config'

export default defineNuxtPlugin({
  name: 'assistant-chat',
  setup () {
    const authStore = useAuthenticationStore()
    const featureFlagStore = useFeatureFlagStore()

    let initializedToken: string | null = null
    const cplugAPI = useRuntimeConfig().public.cplugAPI as ExtendedCPlugAPI

    watch(
      () => ({
        logged: authStore.logged,
        token: authStore.token,
        companyId: authStore.companies?.[0]?.id
      }),
      async ({ logged, token, companyId }) => {
        if (!logged) {
          const { resetChatStore } = await import('@cplug/assistant-chat')
          resetChatStore()

          return
        }

        if (!companyId || (!token && !cplugAPI.withCredentials)) {
          return
        }

        if (!cplugAPI.withCredentials && initializedToken === token) {
          return
        }

        initializedToken = token

        await featureFlagStore.$reset()
        await featureFlagStore.fetch()

        if (featureFlagStore.isEnabled('cplug_assistant')) {
          const { initializeChatStore, setAssistantConfig } = await import('@cplug/assistant-chat')

          setAssistantConfig({
            accessToken: cplugAPI.withCredentials ? undefined : token,
            companyId: String(companyId),
            backendUrl: useRuntimeConfig().public.cplugAPI.baseURL,
            withCredentials: cplugAPI.withCredentials
          })

          initializeChatStore()
        }
      },
      { immediate: true }
    )
  }
})
